
import React from 'react';
import { Mail } from 'lucide-react';
import NotificationTemplatesForm from '@/components/admin/NotificationTemplatesForm';

interface NotificationTemplatesTabProps {
  onSaved: () => void;
}

const NotificationTemplatesTab: React.FC<NotificationTemplatesTabProps> = ({ onSaved }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Mail className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-semibold">Notification Templates</h2>
      </div>
      <NotificationTemplatesForm onSaved={onSaved} />
    </div>
  );
};

export default NotificationTemplatesTab;
